import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import Vue from 'vue';
import Router from 'vue-router';
import { normalizeURL } from 'ufo';
import { interopDefault } from './utils';
import scrollBehavior from './router.scrollBehavior.js';

var _4c5d3a67 = function _4c5d3a67() {
  return interopDefault(import('../pages/account-verification/index.vue'
  /* webpackChunkName: "pages/account-verification/index" */
  ));
};

var _ae2004c8 = function _ae2004c8() {
  return interopDefault(import('../pages/bursaries/index.vue'
  /* webpackChunkName: "pages/bursaries/index" */
  ));
};

var _5b1d543c = function _5b1d543c() {
  return interopDefault(import('../pages/courses/index.vue'
  /* webpackChunkName: "pages/courses/index" */
  ));
};

var _16f48e05 = function _16f48e05() {
  return interopDefault(import('../pages/events/index.vue'
  /* webpackChunkName: "pages/events/index" */
  ));
};

var _72ecbf6e = function _72ecbf6e() {
  return interopDefault(import('../pages/faqs/index.vue'
  /* webpackChunkName: "pages/faqs/index" */
  ));
};

var _1eb528ef = function _1eb528ef() {
  return interopDefault(import('../pages/forgot-password/index.vue'
  /* webpackChunkName: "pages/forgot-password/index" */
  ));
};

var _50f4c906 = function _50f4c906() {
  return interopDefault(import('../pages/general-preferences/index.vue'
  /* webpackChunkName: "pages/general-preferences/index" */
  ));
};

var _507a8f84 = function _507a8f84() {
  return interopDefault(import('../pages/interviews/index.vue'
  /* webpackChunkName: "pages/interviews/index" */
  ));
};

var _347b1d7c = function _347b1d7c() {
  return interopDefault(import('../pages/jobs/index.vue'
  /* webpackChunkName: "pages/jobs/index" */
  ));
};

var _d3b5523e = function _d3b5523e() {
  return interopDefault(import('../pages/LoadTest.vue'
  /* webpackChunkName: "pages/LoadTest" */
  ));
};

var _059af013 = function _059af013() {
  return interopDefault(import('../pages/login/index.vue'
  /* webpackChunkName: "pages/login/index" */
  ));
};

var _35694a38 = function _35694a38() {
  return interopDefault(import('../pages/messages/index.vue'
  /* webpackChunkName: "pages/messages/index" */
  ));
};

var _37a4521f = function _37a4521f() {
  return interopDefault(import('../pages/mock-interviews/index.vue'
  /* webpackChunkName: "pages/mock-interviews/index" */
  ));
};

var _b44d6ce6 = function _b44d6ce6() {
  return interopDefault(import('../pages/my-details/index.vue'
  /* webpackChunkName: "pages/my-details/index" */
  ));
};

var _b9fd197e = function _b9fd197e() {
  return interopDefault(import('../pages/my-jobs/index.vue'
  /* webpackChunkName: "pages/my-jobs/index" */
  ));
};

var _057978fc = function _057978fc() {
  return interopDefault(import('../pages/notification-preferences/index.vue'
  /* webpackChunkName: "pages/notification-preferences/index" */
  ));
};

var _6543c3d2 = function _6543c3d2() {
  return interopDefault(import('../pages/notifications/index.vue'
  /* webpackChunkName: "pages/notifications/index" */
  ));
};

var _d1201ef0 = function _d1201ef0() {
  return interopDefault(import('../pages/saved-jobs/index.vue'
  /* webpackChunkName: "pages/saved-jobs/index" */
  ));
};

var _9faeb762 = function _9faeb762() {
  return interopDefault(import('../pages/settings/index.vue'
  /* webpackChunkName: "pages/settings/index" */
  ));
};

var _aaeb9768 = function _aaeb9768() {
  return interopDefault(import('../pages/university-management/index.vue'
  /* webpackChunkName: "pages/university-management/index" */
  ));
};

var _4a4dc10c = function _4a4dc10c() {
  return interopDefault(import('../pages/welcome/index.vue'
  /* webpackChunkName: "pages/welcome/index" */
  ));
};

var _d2efc0f2 = function _d2efc0f2() {
  return interopDefault(import('../pages/account/create.vue'
  /* webpackChunkName: "pages/account/create" */
  ));
};

var _613ed356 = function _613ed356() {
  return interopDefault(import('../pages/account/edit.vue'
  /* webpackChunkName: "pages/account/edit" */
  ));
};

var _c3854bb2 = function _c3854bb2() {
  return interopDefault(import('../pages/account/verify-university.vue'
  /* webpackChunkName: "pages/account/verify-university" */
  ));
};

var _3e745a7e = function _3e745a7e() {
  return interopDefault(import('../pages/email-verification/backup-email/index.vue'
  /* webpackChunkName: "pages/email-verification/backup-email/index" */
  ));
};

var _b14966b4 = function _b14966b4() {
  return interopDefault(import('../pages/jobs/applications/index.vue'
  /* webpackChunkName: "pages/jobs/applications/index" */
  ));
};

var _5853da8b = function _5853da8b() {
  return interopDefault(import('../pages/profile/create.vue'
  /* webpackChunkName: "pages/profile/create" */
  ));
};

var _8aad79f6 = function _8aad79f6() {
  return interopDefault(import('../pages/profile/cv/index.vue'
  /* webpackChunkName: "pages/profile/cv/index" */
  ));
};

var _afb17b4e = function _afb17b4e() {
  return interopDefault(import('../pages/profile/edit.vue'
  /* webpackChunkName: "pages/profile/edit" */
  ));
};

var _be10cd08 = function _be10cd08() {
  return interopDefault(import('../pages/profile/progress.vue'
  /* webpackChunkName: "pages/profile/progress" */
  ));
};

var _5a7bba90 = function _5a7bba90() {
  return interopDefault(import('../pages/profile/cv/about-me/index.vue'
  /* webpackChunkName: "pages/profile/cv/about-me/index" */
  ));
};

var _a9ebc9f2 = function _a9ebc9f2() {
  return interopDefault(import('../pages/profile/cv/additional/index.vue'
  /* webpackChunkName: "pages/profile/cv/additional/index" */
  ));
};

var _063d90c4 = function _063d90c4() {
  return interopDefault(import('../pages/profile/cv/education/index.vue'
  /* webpackChunkName: "pages/profile/cv/education/index" */
  ));
};

var _63999d32 = function _63999d32() {
  return interopDefault(import('../pages/profile/cv/employability-awards/index.vue'
  /* webpackChunkName: "pages/profile/cv/employability-awards/index" */
  ));
};

var _1aa645ec = function _1aa645ec() {
  return interopDefault(import('../pages/profile/cv/fluent-languages/index.vue'
  /* webpackChunkName: "pages/profile/cv/fluent-languages/index" */
  ));
};

var _dfd56fc8 = function _dfd56fc8() {
  return interopDefault(import('../pages/profile/cv/general-reference/index.vue'
  /* webpackChunkName: "pages/profile/cv/general-reference/index" */
  ));
};

var _6f58a93f = function _6f58a93f() {
  return interopDefault(import('../pages/profile/cv/interests/index.vue'
  /* webpackChunkName: "pages/profile/cv/interests/index" */
  ));
};

var _620787e2 = function _620787e2() {
  return interopDefault(import('../pages/profile/cv/skills/index.vue'
  /* webpackChunkName: "pages/profile/cv/skills/index" */
  ));
};

var _70b140da = function _70b140da() {
  return interopDefault(import('../pages/profile/cv/template/index.vue'
  /* webpackChunkName: "pages/profile/cv/template/index" */
  ));
};

var _235019df = function _235019df() {
  return interopDefault(import('../pages/profile/cv/transport/index.vue'
  /* webpackChunkName: "pages/profile/cv/transport/index" */
  ));
};

var _498e32e1 = function _498e32e1() {
  return interopDefault(import('../pages/profile/cv/upload/index.vue'
  /* webpackChunkName: "pages/profile/cv/upload/index" */
  ));
};

var _460a9848 = function _460a9848() {
  return interopDefault(import('../pages/profile/cv/work-experience/index.vue'
  /* webpackChunkName: "pages/profile/cv/work-experience/index" */
  ));
};

var _dea506b2 = function _dea506b2() {
  return interopDefault(import('../pages/profile/cv/additional/achievement/index.vue'
  /* webpackChunkName: "pages/profile/cv/additional/achievement/index" */
  ));
};

var _7baf62b4 = function _7baf62b4() {
  return interopDefault(import('../pages/profile/cv/additional/external-link/index.vue'
  /* webpackChunkName: "pages/profile/cv/additional/external-link/index" */
  ));
};

var _066e2b55 = function _066e2b55() {
  return interopDefault(import('../pages/profile/cv/additional/external-links/index.vue'
  /* webpackChunkName: "pages/profile/cv/additional/external-links/index" */
  ));
};

var _c9850664 = function _c9850664() {
  return interopDefault(import('../pages/profile/cv/education/additional/index.vue'
  /* webpackChunkName: "pages/profile/cv/education/additional/index" */
  ));
};

var _57ece9db = function _57ece9db() {
  return interopDefault(import('../pages/profile/cv/education/school/index.vue'
  /* webpackChunkName: "pages/profile/cv/education/school/index" */
  ));
};

var _7838b639 = function _7838b639() {
  return interopDefault(import('../pages/profile/cv/education/tertiary/index.vue'
  /* webpackChunkName: "pages/profile/cv/education/tertiary/index" */
  ));
};

var _0ad289bb = function _0ad289bb() {
  return interopDefault(import('../pages/profile/cv/employability-awards/checklist.vue'
  /* webpackChunkName: "pages/profile/cv/employability-awards/checklist" */
  ));
};

var _41a29dce = function _41a29dce() {
  return interopDefault(import('../pages/profile/cv/employability-awards/ChecklistItem.vue'
  /* webpackChunkName: "pages/profile/cv/employability-awards/ChecklistItem" */
  ));
};

var _b85eea4c = function _b85eea4c() {
  return interopDefault(import('../pages/profile/cv/employability-awards/LogUpload.vue'
  /* webpackChunkName: "pages/profile/cv/employability-awards/LogUpload" */
  ));
};

var _5af07ccf = function _5af07ccf() {
  return interopDefault(import('../pages/profile/cv/additional/achievement/_id.vue'
  /* webpackChunkName: "pages/profile/cv/additional/achievement/_id" */
  ));
};

var _295e821c = function _295e821c() {
  return interopDefault(import('../pages/profile/cv/additional/external-link/_id.vue'
  /* webpackChunkName: "pages/profile/cv/additional/external-link/_id" */
  ));
};

var _2bff4a94 = function _2bff4a94() {
  return interopDefault(import('../pages/profile/cv/education/additional/_id.vue'
  /* webpackChunkName: "pages/profile/cv/education/additional/_id" */
  ));
};

var _55d1a703 = function _55d1a703() {
  return interopDefault(import('../pages/profile/cv/education/school/_id.vue'
  /* webpackChunkName: "pages/profile/cv/education/school/_id" */
  ));
};

var _74c0f2e1 = function _74c0f2e1() {
  return interopDefault(import('../pages/profile/cv/education/tertiary/_id.vue'
  /* webpackChunkName: "pages/profile/cv/education/tertiary/_id" */
  ));
};

var _794ea184 = function _794ea184() {
  return interopDefault(import('../pages/profile/cv/general-reference/_id.vue'
  /* webpackChunkName: "pages/profile/cv/general-reference/_id" */
  ));
};

var _441bfd44 = function _441bfd44() {
  return interopDefault(import('../pages/profile/cv/work-experience/_id.vue'
  /* webpackChunkName: "pages/profile/cv/work-experience/_id" */
  ));
};

var _30d1a491 = function _30d1a491() {
  return interopDefault(import('../pages/jobs/applications/_id/index.vue'
  /* webpackChunkName: "pages/jobs/applications/_id/index" */
  ));
};

var _0618ea87 = function _0618ea87() {
  return interopDefault(import('../pages/bursaries/_id/index.vue'
  /* webpackChunkName: "pages/bursaries/_id/index" */
  ));
};

var _5f049bb4 = function _5f049bb4() {
  return interopDefault(import('../pages/interviews/_id.vue'
  /* webpackChunkName: "pages/interviews/_id" */
  ));
};

var _30c5c9a6 = function _30c5c9a6() {
  return interopDefault(import('../pages/jobs/_id/index.vue'
  /* webpackChunkName: "pages/jobs/_id/index" */
  ));
};

var _60b47aa0 = function _60b47aa0() {
  return interopDefault(import('../pages/messages/_id.vue'
  /* webpackChunkName: "pages/messages/_id" */
  ));
};

var _3f001626 = function _3f001626() {
  return interopDefault(import('../pages/reset-password/_id.vue'
  /* webpackChunkName: "pages/reset-password/_id" */
  ));
};

var _079a0d08 = function _079a0d08() {
  return interopDefault(import('../pages/bursaries/_id/application/index.vue'
  /* webpackChunkName: "pages/bursaries/_id/application/index" */
  ));
};

var _056716a4 = function _056716a4() {
  return interopDefault(import('../pages/jobs/_id/application/index.vue'
  /* webpackChunkName: "pages/jobs/_id/application/index" */
  ));
};

var _d14d9b0e = function _d14d9b0e() {
  return interopDefault(import('../pages/index.vue'
  /* webpackChunkName: "pages/index" */
  ));
};

var emptyFn = function emptyFn() {};

Vue.use(Router);
export var routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior: scrollBehavior,
  routes: [{
    path: "/account-verification",
    component: _4c5d3a67,
    name: "account-verification___en"
  }, {
    path: "/af/account-verification",
    component: _4c5d3a67,
    name: "account-verification___af"
  }, {
    path: "/bursaries",
    component: _ae2004c8,
    name: "bursaries___en"
  }, {
    path: "/af/bursaries",
    component: _ae2004c8,
    name: "bursaries___af"
  }, {
    path: "/courses",
    component: _5b1d543c,
    name: "courses___en"
  }, {
    path: "/af/courses",
    component: _5b1d543c,
    name: "courses___af"
  }, {
    path: "/events",
    component: _16f48e05,
    name: "events___en"
  }, {
    path: "/af/events",
    component: _16f48e05,
    name: "events___af"
  }, {
    path: "/faqs",
    component: _72ecbf6e,
    name: "faqs___en"
  }, {
    path: "/af/faqs",
    component: _72ecbf6e,
    name: "faqs___af"
  }, {
    path: "/forgot-password",
    component: _1eb528ef,
    name: "forgot-password___en"
  }, {
    path: "/af/forgot-password",
    component: _1eb528ef,
    name: "forgot-password___af"
  }, {
    path: "/general-preferences",
    component: _50f4c906,
    name: "general-preferences___en"
  }, {
    path: "/af/general-preferences",
    component: _50f4c906,
    name: "general-preferences___af"
  }, {
    path: "/interviews",
    component: _507a8f84,
    name: "interviews___en"
  }, {
    path: "/af/interviews",
    component: _507a8f84,
    name: "interviews___af"
  }, {
    path: "/jobs",
    component: _347b1d7c,
    name: "jobs___en"
  }, {
    path: "/af/jobs",
    component: _347b1d7c,
    name: "jobs___af"
  }, {
    path: "/LoadTest",
    component: _d3b5523e,
    name: "LoadTest___en"
  }, {
    path: "/af/LoadTest",
    component: _d3b5523e,
    name: "LoadTest___af"
  }, {
    path: "/login",
    component: _059af013,
    name: "login___en"
  }, {
    path: "/af/login",
    component: _059af013,
    name: "login___af"
  }, {
    path: "/messages",
    component: _35694a38,
    name: "messages___en"
  }, {
    path: "/af/messages",
    component: _35694a38,
    name: "messages___af"
  }, {
    path: "/mock-interviews",
    component: _37a4521f,
    name: "mock-interviews___en"
  }, {
    path: "/af/mock-interviews",
    component: _37a4521f,
    name: "mock-interviews___af"
  }, {
    path: "/my-details",
    component: _b44d6ce6,
    name: "my-details___en"
  }, {
    path: "/af/my-details",
    component: _b44d6ce6,
    name: "my-details___af"
  }, {
    path: "/my-jobs",
    component: _b9fd197e,
    name: "my-jobs___en"
  }, {
    path: "/af/my-jobs",
    component: _b9fd197e,
    name: "my-jobs___af"
  }, {
    path: "/notification-preferences",
    component: _057978fc,
    name: "notification-preferences___en"
  }, {
    path: "/af/notification-preferences",
    component: _057978fc,
    name: "notification-preferences___af"
  }, {
    path: "/notifications",
    component: _6543c3d2,
    name: "notifications___en"
  }, {
    path: "/af/notifications",
    component: _6543c3d2,
    name: "notifications___af"
  }, {
    path: "/saved-jobs",
    component: _d1201ef0,
    name: "saved-jobs___en"
  }, {
    path: "/af/saved-jobs",
    component: _d1201ef0,
    name: "saved-jobs___af"
  }, {
    path: "/settings",
    component: _9faeb762,
    name: "settings___en"
  }, {
    path: "/af/settings",
    component: _9faeb762,
    name: "settings___af"
  }, {
    path: "/university-management",
    component: _aaeb9768,
    name: "university-management___en"
  }, {
    path: "/af/university-management",
    component: _aaeb9768,
    name: "university-management___af"
  }, {
    path: "/welcome",
    component: _4a4dc10c,
    name: "welcome___en"
  }, {
    path: "/af/welcome",
    component: _4a4dc10c,
    name: "welcome___af"
  }, {
    path: "/account/create",
    component: _d2efc0f2,
    name: "account-create___en"
  }, {
    path: "/af/account/create",
    component: _d2efc0f2,
    name: "account-create___af"
  }, {
    path: "/account/edit",
    component: _613ed356,
    name: "account-edit___en"
  }, {
    path: "/af/account/edit",
    component: _613ed356,
    name: "account-edit___af"
  }, {
    path: "/account/verify-university",
    component: _c3854bb2,
    name: "account-verify-university___en"
  }, {
    path: "/af/account/verify-university",
    component: _c3854bb2,
    name: "account-verify-university___af"
  }, {
    path: "/email-verification/backup-email",
    component: _3e745a7e,
    name: "email-verification-backup-email___en"
  }, {
    path: "/af/email-verification/backup-email",
    component: _3e745a7e,
    name: "email-verification-backup-email___af"
  }, {
    path: "/jobs/applications",
    component: _b14966b4,
    name: "jobs-applications___en"
  }, {
    path: "/af/jobs/applications",
    component: _b14966b4,
    name: "jobs-applications___af"
  }, {
    path: "/profile/create",
    component: _5853da8b,
    name: "profile-create___en"
  }, {
    path: "/af/profile/create",
    component: _5853da8b,
    name: "profile-create___af"
  }, {
    path: "/profile/cv",
    component: _8aad79f6,
    name: "profile-cv___en"
  }, {
    path: "/af/profile/cv",
    component: _8aad79f6,
    name: "profile-cv___af"
  }, {
    path: "/profile/edit",
    component: _afb17b4e,
    name: "profile-edit___en"
  }, {
    path: "/af/profile/edit",
    component: _afb17b4e,
    name: "profile-edit___af"
  }, {
    path: "/profile/progress",
    component: _be10cd08,
    name: "profile-progress___en"
  }, {
    path: "/af/profile/progress",
    component: _be10cd08,
    name: "profile-progress___af"
  }, {
    path: "/profile/cv/about-me",
    component: _5a7bba90,
    name: "profile-cv-about-me___en"
  }, {
    path: "/af/profile/cv/about-me",
    component: _5a7bba90,
    name: "profile-cv-about-me___af"
  }, {
    path: "/profile/cv/additional",
    component: _a9ebc9f2,
    name: "profile-cv-additional___en"
  }, {
    path: "/af/profile/cv/additional",
    component: _a9ebc9f2,
    name: "profile-cv-additional___af"
  }, {
    path: "/profile/cv/education",
    component: _063d90c4,
    name: "profile-cv-education___en"
  }, {
    path: "/af/profile/cv/education",
    component: _063d90c4,
    name: "profile-cv-education___af"
  }, {
    path: "/profile/cv/employability-awards",
    component: _63999d32,
    name: "profile-cv-employability-awards___en"
  }, {
    path: "/af/profile/cv/employability-awards",
    component: _63999d32,
    name: "profile-cv-employability-awards___af"
  }, {
    path: "/profile/cv/fluent-languages",
    component: _1aa645ec,
    name: "profile-cv-fluent-languages___en"
  }, {
    path: "/af/profile/cv/fluent-languages",
    component: _1aa645ec,
    name: "profile-cv-fluent-languages___af"
  }, {
    path: "/profile/cv/general-reference",
    component: _dfd56fc8,
    name: "profile-cv-general-reference___en"
  }, {
    path: "/af/profile/cv/general-reference",
    component: _dfd56fc8,
    name: "profile-cv-general-reference___af"
  }, {
    path: "/profile/cv/interests",
    component: _6f58a93f,
    name: "profile-cv-interests___en"
  }, {
    path: "/af/profile/cv/interests",
    component: _6f58a93f,
    name: "profile-cv-interests___af"
  }, {
    path: "/profile/cv/skills",
    component: _620787e2,
    name: "profile-cv-skills___en"
  }, {
    path: "/af/profile/cv/skills",
    component: _620787e2,
    name: "profile-cv-skills___af"
  }, {
    path: "/profile/cv/template",
    component: _70b140da,
    name: "profile-cv-template___en"
  }, {
    path: "/af/profile/cv/template",
    component: _70b140da,
    name: "profile-cv-template___af"
  }, {
    path: "/profile/cv/transport",
    component: _235019df,
    name: "profile-cv-transport___en"
  }, {
    path: "/af/profile/cv/transport",
    component: _235019df,
    name: "profile-cv-transport___af"
  }, {
    path: "/profile/cv/upload",
    component: _498e32e1,
    name: "profile-cv-upload___en"
  }, {
    path: "/af/profile/cv/upload",
    component: _498e32e1,
    name: "profile-cv-upload___af"
  }, {
    path: "/profile/cv/work-experience",
    component: _460a9848,
    name: "profile-cv-work-experience___en"
  }, {
    path: "/af/profile/cv/work-experience",
    component: _460a9848,
    name: "profile-cv-work-experience___af"
  }, {
    path: "/profile/cv/additional/achievement",
    component: _dea506b2,
    name: "profile-cv-additional-achievement___en"
  }, {
    path: "/af/profile/cv/additional/achievement",
    component: _dea506b2,
    name: "profile-cv-additional-achievement___af"
  }, {
    path: "/profile/cv/additional/external-link",
    component: _7baf62b4,
    name: "profile-cv-additional-external-link___en"
  }, {
    path: "/af/profile/cv/additional/external-link",
    component: _7baf62b4,
    name: "profile-cv-additional-external-link___af"
  }, {
    path: "/profile/cv/additional/external-links",
    component: _066e2b55,
    name: "profile-cv-additional-external-links___en"
  }, {
    path: "/af/profile/cv/additional/external-links",
    component: _066e2b55,
    name: "profile-cv-additional-external-links___af"
  }, {
    path: "/profile/cv/education/additional",
    component: _c9850664,
    name: "profile-cv-education-additional___en"
  }, {
    path: "/af/profile/cv/education/additional",
    component: _c9850664,
    name: "profile-cv-education-additional___af"
  }, {
    path: "/profile/cv/education/school",
    component: _57ece9db,
    name: "profile-cv-education-school___en"
  }, {
    path: "/af/profile/cv/education/school",
    component: _57ece9db,
    name: "profile-cv-education-school___af"
  }, {
    path: "/profile/cv/education/tertiary",
    component: _7838b639,
    name: "profile-cv-education-tertiary___en"
  }, {
    path: "/af/profile/cv/education/tertiary",
    component: _7838b639,
    name: "profile-cv-education-tertiary___af"
  }, {
    path: "/profile/cv/employability-awards/checklist",
    component: _0ad289bb,
    name: "profile-cv-employability-awards-checklist___en"
  }, {
    path: "/af/profile/cv/employability-awards/checklist",
    component: _0ad289bb,
    name: "profile-cv-employability-awards-checklist___af"
  }, {
    path: "/profile/cv/employability-awards/ChecklistItem",
    component: _41a29dce,
    name: "profile-cv-employability-awards-ChecklistItem___en"
  }, {
    path: "/af/profile/cv/employability-awards/ChecklistItem",
    component: _41a29dce,
    name: "profile-cv-employability-awards-ChecklistItem___af"
  }, {
    path: "/profile/cv/employability-awards/LogUpload",
    component: _b85eea4c,
    name: "profile-cv-employability-awards-LogUpload___en"
  }, {
    path: "/af/profile/cv/employability-awards/LogUpload",
    component: _b85eea4c,
    name: "profile-cv-employability-awards-LogUpload___af"
  }, {
    path: "/profile/cv/additional/achievement/:id",
    component: _5af07ccf,
    name: "profile-cv-additional-achievement-id___en"
  }, {
    path: "/af/profile/cv/additional/achievement/:id",
    component: _5af07ccf,
    name: "profile-cv-additional-achievement-id___af"
  }, {
    path: "/profile/cv/additional/external-link/:id?",
    component: _295e821c,
    name: "profile-cv-additional-external-link-id___en"
  }, {
    path: "/af/profile/cv/additional/external-link/:id?",
    component: _295e821c,
    name: "profile-cv-additional-external-link-id___af"
  }, {
    path: "/profile/cv/education/additional/:id",
    component: _2bff4a94,
    name: "profile-cv-education-additional-id___en"
  }, {
    path: "/af/profile/cv/education/additional/:id",
    component: _2bff4a94,
    name: "profile-cv-education-additional-id___af"
  }, {
    path: "/profile/cv/education/school/:id",
    component: _55d1a703,
    name: "profile-cv-education-school-id___en"
  }, {
    path: "/af/profile/cv/education/school/:id",
    component: _55d1a703,
    name: "profile-cv-education-school-id___af"
  }, {
    path: "/profile/cv/education/tertiary/:id",
    component: _74c0f2e1,
    name: "profile-cv-education-tertiary-id___en"
  }, {
    path: "/af/profile/cv/education/tertiary/:id",
    component: _74c0f2e1,
    name: "profile-cv-education-tertiary-id___af"
  }, {
    path: "/profile/cv/general-reference/:id?",
    component: _794ea184,
    name: "profile-cv-general-reference-id___en"
  }, {
    path: "/af/profile/cv/general-reference/:id?",
    component: _794ea184,
    name: "profile-cv-general-reference-id___af"
  }, {
    path: "/profile/cv/work-experience/:id?",
    component: _441bfd44,
    name: "profile-cv-work-experience-id___en"
  }, {
    path: "/af/profile/cv/work-experience/:id?",
    component: _441bfd44,
    name: "profile-cv-work-experience-id___af"
  }, {
    path: "/jobs/applications/:id",
    component: _30d1a491,
    name: "jobs-applications-id___en"
  }, {
    path: "/af/jobs/applications/:id",
    component: _30d1a491,
    name: "jobs-applications-id___af"
  }, {
    path: "/bursaries/:id",
    component: _0618ea87,
    name: "bursaries-id___en"
  }, {
    path: "/af/bursaries/:id",
    component: _0618ea87,
    name: "bursaries-id___af"
  }, {
    path: "/interviews/:id",
    component: _5f049bb4,
    name: "interviews-id___en"
  }, {
    path: "/af/interviews/:id",
    component: _5f049bb4,
    name: "interviews-id___af"
  }, {
    path: "/jobs/:id",
    component: _30c5c9a6,
    name: "jobs-id___en"
  }, {
    path: "/af/jobs/:id",
    component: _30c5c9a6,
    name: "jobs-id___af"
  }, {
    path: "/messages/:id",
    component: _60b47aa0,
    name: "messages-id___en"
  }, {
    path: "/af/messages/:id",
    component: _60b47aa0,
    name: "messages-id___af"
  }, {
    path: "/reset-password/:id?",
    component: _3f001626,
    name: "reset-password-id___en"
  }, {
    path: "/af/reset-password/:id?",
    component: _3f001626,
    name: "reset-password-id___af"
  }, {
    path: "/bursaries/:id/application",
    component: _079a0d08,
    name: "bursaries-id-application___en"
  }, {
    path: "/af/bursaries/:id/application",
    component: _079a0d08,
    name: "bursaries-id-application___af"
  }, {
    path: "/jobs/:id/application",
    component: _056716a4,
    name: "jobs-id-application___en"
  }, {
    path: "/af/jobs/:id/application",
    component: _056716a4,
    name: "jobs-id-application___af"
  }, {
    path: "/",
    component: _d14d9b0e,
    name: "index___en"
  }, {
    path: "/af",
    component: _d14d9b0e,
    name: "index___af"
  }],
  fallback: false
};
export function createRouter(ssrContext, config) {
  var base = config._app && config._app.basePath || routerOptions.base;
  var router = new Router(_objectSpread(_objectSpread({}, routerOptions), {}, {
    base: base
  })); // TODO: remove in Nuxt 3

  var originalPush = router.push;

  router.push = function push(location) {
    var onComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyFn;
    var onAbort = arguments.length > 2 ? arguments[2] : undefined;
    return originalPush.call(this, location, onComplete, onAbort);
  };

  var resolve = router.resolve.bind(router);

  router.resolve = function (to, current, append) {
    if (typeof to === 'string') {
      to = normalizeURL(to);
    }

    return resolve(to, current, append);
  };

  return router;
}